import { Injectable } from '@angular/core';
import { MenuAccess, MenuItem } from 'app/core/user/user.types';

@Injectable({ providedIn: 'root' })
export class AccessService {
    private _accessMap = new Map<string, MenuAccess>();
    private _isLoaded = false;

    load(menuItems: MenuItem[]): void {
        this._accessMap.clear();
        this._flattenMenuItems(menuItems);
        this._isLoaded = true;
    }

    isLoaded(): boolean {
        return this._isLoaded;
    }

    getAccess(menuId: string): MenuAccess {
        return this._accessMap.get(menuId) ?? 'HIDDEN';
    }

    canRead(menuId: string): boolean {
        return this.getAccess(menuId) !== 'HIDDEN';
    }

    canWrite(menuId: string): boolean {
        return this.getAccess(menuId) === 'WRITE';
    }

    private _flattenMenuItems(items: MenuItem[]): void {
        if (!items) return;
        for (const item of items) {
            const resolved = this._resolveAccess(item);
            if (item.menuId) {
                this._accessMap.set(item.menuId, resolved);
            }
            if (item.children?.length) {
                this._flattenMenuItems(item.children);
            }
        }
    }

    private _resolveAccess(item: MenuItem): MenuAccess {
        if (item.access) {
            return item.access;
        }
        return item.isGiven ? 'WRITE' : 'HIDDEN';
    }
}
